
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","height":"800px","width":"800px","version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512.048 512.048","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('g',[_c('path',{attrs:{"d":"M403.331,245.808c26.667-59.947,51.307-146.453,33.173-193.067c-25.707-65.92-80.747-55.04-129.28-45.547\r\n\t\t\tc-17.28,3.413-35.2,6.933-51.2,6.933s-33.92-3.52-51.2-6.933c-48.533-9.6-103.467-20.373-129.28,45.547\r\n\t\t\tc-18.133,46.507,6.507,133.12,33.173,193.067c0.747,1.707,1.067,3.52,0.853,5.333c-2.56,25.067-3.84,50.347-3.733,75.52\r\n\t\t\tc0,68.8,10.453,185.387,49.387,185.387c33.387,0,37.973-44.267,42.88-91.2c6.933-67.52,15.253-115.307,57.92-115.307\r\n\t\t\tc42.027,0,50.133,47.36,57.067,114.133c4.907,47.467,9.493,92.267,43.733,92.267c39.04,0,49.493-116.587,49.493-185.387\r\n\t\t\tc0-25.173-1.173-50.347-3.733-75.52C402.264,249.328,402.584,247.408,403.331,245.808z M356.717,490.715\r\n\t\t\tc-14.933,0-18.987-38.933-22.507-73.173c-6.187-59.413-13.76-133.333-78.293-133.333c-65.173,0-72.96,74.56-79.147,134.4\r\n\t\t\tc-3.52,33.813-7.467,72.107-21.12,72.107c-10.24-4.16-28.587-62.4-28.587-164.16c-0.107-24.533,1.173-48.96,3.627-73.28\r\n\t\t\tc0.533-5.547-0.32-11.093-2.56-16.107C96.237,165.381,82.797,92.741,95.384,60.528c11.733-29.973,29.547-39.147,54.827-39.147\r\n\t\t\tc14.4,0,31.04,2.987,50.453,6.827c18.347,3.627,37.333,7.36,55.36,7.36s37.013-3.733,55.36-7.36\r\n\t\t\tc53.333-10.56,86.933-14.613,105.28,32.32c12.587,32.213-0.96,104.853-32.747,176.64c-2.24,5.12-3.2,10.667-2.56,16.32\r\n\t\t\tc2.453,24.32,3.627,48.747,3.627,73.28C384.877,428.315,366.531,486.661,356.717,490.715z"}})])])])
          )
        }
      }
    